import { useContext } from "react";
import { AvisConstants } from "../../../data/avisConstants";
import { AuthorsUtils } from "../../../utils";
import { LandingPage } from "../../shared/components/landingPage/LandingPage";
import { LandingPageAction } from "../../shared/components/landingPage/LandingPageAction";
import { AvisContext } from "../../shared/context/AvisContext";

export function LandingPageAuthors() {
  const { ctxRightsHolder, res } = useContext(AvisContext);

  return (
    <LandingPage
      title={res("authors_LandingPage_WelcomeText")}
      textKey="portal_RH_Start_1"
    >
      <LandingPageAction
        buttonText={res("authors_LandingPage_Button_RegisterCreation")}
        navigateTo={AuthorsUtils.getRightsHolderPagePath(
          ctxRightsHolder,
          `${AvisConstants.url_part_creations}/new`,
        )}
        textKey="portal_RH_Start_2"
      />
      <LandingPageAction
        buttonText={res("authors_LandingPage_Button_BillingData")}
        navigateTo={AuthorsUtils.getRightsHolderPagePath(
          ctxRightsHolder,
          "billing-data",
        )}
        textKey="portal_RH_Start_3"
      />
      <LandingPageAction
        buttonText={res("authors_LandingPage_Button_Reports")}
        navigateTo={AuthorsUtils.getRightsHolderPagePath(
          ctxRightsHolder,
          "reports",
        )}
        textKey="portal_RH_Start_4"
      />
    </LandingPage>
  );
}
